import React from 'react';
import { Twitter } from 'react-feather';
import styled from 'styled-components';
import IconContainer from './IconContainer';
const IconContainerExtended = styled(IconContainer) `
    background: #1da1f2;
`;
const IxuTwitter = (props) => (React.createElement(IconContainerExtended, { ...props },
    React.createElement(Twitter, { color: "white" })));
export default IxuTwitter;
//# sourceMappingURL=IxuTwitter.js.map